











































import { Critter } from '@/shared/models/critter';
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
  name: 'CritterList',
  data() {
    return {
      selectedCritters: [] as Critter[],
    };
  },
  props: {
    critterType: {
      type: String,
      required: true,
      default: '',
    },
    critterList: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    visibleCritters(): number {
      let countVisible = this.critterList.length;
      this.critterList.forEach((critter: any) => {
        if (critter['show'] === 'hide') {
          countVisible--;
        }
      });
      return countVisible;
    },
    ...mapState({ user: (state: any): string => state.user.user }),
  },
  methods: {
    ...mapActions('user', ['updateUserCritterInfo']),

    async checkCritter(critter: Critter) {
      await this.updateUserCritterInfo({ id: critter.id.toString(), type: this.critterType });
    },

    onSelectCritter(critter: Critter) {
      this.$emit('selectCritter', critter);
    },

    currentCritterColor(critter) {
      switch (critter.rarity) {
        case 'Uncommon':
          return 'list__elem--uncommon';
        case 'Rare':
          return 'list__elem--rare';
        case 'Ultra-rare':
          return 'list__elem--ultra-rare';
        default:
          return 'list__elem--common';
      }
    },
  },
});
